import { Box, Text } from '@chakra-ui/react';
import React from 'react';

import { finleyAssertUnreachable } from '@finley-technologies/common';
import { Bank, CreditAgreement } from '@finley-technologies/finley-types';

import {
  formatSelectOptions,
  Select,
} from '~/packages/common-frontend/components/Select';
import { WipConfig } from '~/packages/creditAgreements/ui/types';

export const updateFinancialCovenantLimitValueType = (params: {
  value: number;
  valueType: CreditAgreement.Config.FinancialCovenant.LimitValueType;
}): CreditAgreement.DomainEntity.FinancialCovenantLimit => {
  const { value, valueType } = params;
  switch (valueType) {
    case CreditAgreement.Config.FinancialCovenant.LimitValueType.currency:
      return {
        value,
        valueType:
          CreditAgreement.Config.FinancialCovenant.LimitValueType.currency,
        currency: Bank.Currency.USD,
      };
    case CreditAgreement.Config.FinancialCovenant.LimitValueType.ratio:
    case CreditAgreement.Config.FinancialCovenant.LimitValueType.percentage:
      return {
        value,
        valueType,
      };
    default:
      return finleyAssertUnreachable(valueType);
  }
};

type FinancialCovenantLimitValueTypeSelectorProps = {
  wipConfig?: WipConfig;
  fullPropertyKey: string;
  limitProperty: CreditAgreement.DomainEntity.FinancialCovenantLimit;
};
export const FinancialCovenantLimitValueTypeSelector = ({
  wipConfig,
  fullPropertyKey,
  limitProperty,
}: FinancialCovenantLimitValueTypeSelectorProps) => {
  return (
    <Box mb="2">
      <Text fontWeight="bold" fontSize="large" mr="2" mb="16px">
        Value Type
      </Text>
      <Select
        isDisabled={!wipConfig?.isMutateAllowed(fullPropertyKey)}
        value={limitProperty.valueType}
        options={formatSelectOptions(
          Object.values(
            CreditAgreement.Config.FinancialCovenant.LimitValueType,
          ),
          'title',
        )}
        onChange={async (newValue) => {
          if (
            newValue &&
            newValue !== limitProperty.valueType &&
            wipConfig?.isMutateAllowed(fullPropertyKey)
          ) {
            const newLimitProperty = updateFinancialCovenantLimitValueType({
              value: limitProperty.value,
              valueType: newValue,
            });

            await wipConfig.saveAndUpdateConfigCreditAgreementWip({
              wipConfig,
              propertyKey: fullPropertyKey,
              updatedProperty: newLimitProperty,
            });
          }
        }}
        width="460px"
        height="8"
      />
    </Box>
  );
};
